import { InputAdornmentButton } from '@cian/ui-kit';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useModalState } from 'shared/hooks';
import { LocationSwitcherModalContainer } from '../ModalContainer';
import { loadLocationSwitcherData } from 'shared/thunks/geo/locationSwitcher';
import { trackOpenGeoModal } from './tracking';
import { selectIsGeoModalOpen } from 'shared/selectors/geo';
import { useSelector } from 'react-redux';
import { closeGeoModal } from 'shared/slices/geo/slice';
import { trackQuickFilterClick } from 'shared/utils/analytics/trackQuickFiltersEvents';

export const LocationSwitcherPopupButtonContainer = () => {
  const dispatch = useAppDispatch();
  const isModalOpened = useSelector(selectIsGeoModalOpen);

  const { opened, onClose, onOpen } = useModalState();

  const handleClose = useCallback(() => {
    onClose();
    dispatch(closeGeoModal());
  }, [onClose, dispatch]);

  const openModal = useCallback(() => {
    onOpen();
    dispatch(loadLocationSwitcherData());
    trackOpenGeoModal();
  }, [dispatch, onOpen]);

  const handleClick = useCallback(() => {
    trackQuickFilterClick('region');
    openModal();
  }, [openModal]);

  useEffect(() => {
    if (isModalOpened) {
      openModal();
    }
  }, [isModalOpened, openModal]);

  return (
    <>
      <InputAdornmentButton
        type="button"
        onClick={handleClick}
        data-testid="LocationSwitcherButton"
        data-name="LocationSwitcherPopupButtonContainer"
      >
        Регион
      </InputAdornmentButton>
      {opened && <LocationSwitcherModalContainer onModalClose={handleClose} />}
    </>
  );
};
